import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Notification} from '../../data/Notification';
import {NotificationService} from '../../services/notification/notification.service';
import {EntityType} from '../../data/EntityType';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {UserService} from '../../../user/services/user/user.service';
import {NavigationService} from '../../services/navigation.service';
import {TabbingService} from "../../../tabbing/services/tabbing.service";
import {AppService} from "../../services/app/app.service";

@Component({
  selector: 'app-notification-list-entry',
  templateUrl: './notification-list-entry.component.html',
  styleUrls: ['./notification-list-entry.component.scss'],
  animations: [
    trigger('readState', [
      state('unread', style({
        color: 'black'
      })),
      state('read', style({
        color: 'grey'
      })),
      transition('unread => read', animate('250ms ease-out')),
      transition('read => unread', animate('250ms ease-in'))
    ])
  ]
})
export class NotificationListEntryComponent implements OnInit {
  @ViewChild('notificationElement') notificationElement: ElementRef;

  @Input() notification: Notification;
  @Input() indexTag: number;

  @Output() dismissNotificationEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeNotificationPopup: EventEmitter<boolean> = new EventEmitter<boolean>();

  formattedTime: string;
  notificationIcon: string;
  readState: boolean;

  constructor(private notificationService: NotificationService,
              private userService: UserService,
              private navigationService: NavigationService,
              public tabbingService: TabbingService,
              public appService: AppService) {
  }

  ngOnInit(): void {
    this.getReadStatus();
    const dateObj = new Date(this.notification.createdOn);
    const dateString = `${(dateObj.getMonth() + 1).toString().padStart(2, '0')}/${dateObj.getDate().toString().padStart(2, '0')}/${dateObj.getFullYear()} ${dateObj.getHours().toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}`;
    this.formattedTime = dateString;

    this.notificationIcon = this.entityIcon;
  }

  getReadStatus() {
    const currentUser = this.userService.currentUser.accountId;
    this.readState = this.notification.userNotifications.filter(x => x.userId === currentUser)[0].read;
  }

  async changeReadStatus() {
    await this.notificationService.readNotification(this.notification.id).then(_ => {
      const notif = this.notification.userNotifications.find(x => x.userId === this.userService.currentUser.accountId);
      notif.read = !notif.read;
    });
    this.readState = !this.readState;

  }

  redirectToEntity() {
    if (this.tabbingService.tabs.length >= 10 ){
      this.appService.showInfoMessage('Maximum tabs limit has been reached. Please close at lease 1 tab.');
    } else {
      let path;
      switch (this.notification.entityType) {
        case EntityType.Document:
          path = '/docs';
          break;
        case EntityType.Snippet:
          path = '/snippets';
          break;
        case EntityType.Communication:
          path = '/communications';
          break;
        case EntityType.Job:
          path = '/jobs';
          break;
        case EntityType.Appointment:
          path = '/appointments';
          break;
        case EntityType.Customer:
          path = '/contacts';
          break;
      }
      this.closeNotificationPopup.emit(true);
      this.navigationService.navigateInNewTab([path, this.notification.entityId.toString()]);
    }
  }

  get entityIcon(): string {
    switch (this.notification.entityType) {
      case EntityType.Appointment:
        return 'fas fa-calendar';
      case EntityType.Customer:
        return 'fas fa-user-tie';
      case EntityType.Job:
        return 'fas fa-briefcase';
      case EntityType.Communication:
        return 'fas fa-phone';
      case EntityType.Snippet:
        return 'fas fa-cut';
      case EntityType.Document:
        return 'fas fa-info';
    }
  }

  async dismissNotification(): Promise<void> {
    await this.notificationService.dismissNotification(this.notification.id).then(() => {
      this.applyDisappearAnimation();
      const notif = this.notification.userNotifications.find(x => x.userId === this.userService.currentUser.accountId);
      notif.dismissed = !notif.dismissed;
      setTimeout(() => {
        this.dismissNotificationEvent.emit(true);
      }, 500);
    });

  }

  applyDisappearAnimation() {
    this.notificationElement.nativeElement.animate(this.getFadeAnimation(), this.getFadeAnimationTiming());
  }

  getFadeAnimation() {
    return [
      {opacity: 0}
    ];
  }

  getFadeAnimationTiming() {
    return {
      duration: 500,
      iterations: 1,
    };
  }
}
